import { z } from "zod";

export const publicGivingSchema = z.object({
  id: z.number(),
  published_at: z.iso.datetime(),
  goal_amount: z.number(),
  hallow_match: z
    .object({
      max_amount: z.number(),
      current_amount: z.number(),
      description: z.string(),
    })
    .nullable(),
  description: z.string().nullable().optional(),
  current_amount_of_all_successful_and_pending_payments: z.number(),
  current_total_raised_including_match: z.number(),
  number_of_donations: z.number(),
  average_donation_amount: z.number().optional(),
  highest_donation_amount: z.number().optional(),
});

export const givingSchema = publicGivingSchema.extend({
  my_donations: z
    .object({
      status: z.enum([
        "created",
        "pending",
        "successful",
        "canceled",
        "failed",
        "unknown",
      ]),
      amount: z.number(),
      last_updated_at: z.iso.datetime(),
    })
    .array()
    .optional(),
});

export type GivingDetails = z.infer<typeof givingSchema>;
